import React from "react";
import "./project.css";
import Button from "../Styled/Button";

const Project = () => {
  return (
    <div className="containerProject" id="aboutProject">
      <div className="container-title">
        <h1>Project</h1>
      </div>
      <div className="container-project-info" data-aos="fade-up" data-aos-duration="3000">
        <div className="project-info">
          <h4>Deposit account</h4>
          <p>$ 116,475,896.03</p>
        </div>
        <div className="project-info">
          <h4>Withdraw</h4>
          <p>$ 78,412,955.01</p>
        </div>
        <div className="project-info">
          <h4>Active account</h4>
          <p>46,590</p>
        </div>
      </div>
      <div className="container-btn-project">
        <Button>PLAY NOW</Button>
      </div>
    </div>
  );
};

export default Project;
